export const saveState = (state, nameKey) => {
    try {
        const serializedState = JSON.stringify(state);
        localStorage.setItem(nameKey, serializedState);
    } catch (e) {}
};

export const loadState = (nameKey) => {
    try {
        const serializedState = localStorage.getItem(nameKey);
        if (serializedState === null) {
            return undefined;
        }
        return JSON.parse(serializedState);
    } catch (e) {
        return undefined;
    }
};
